import React from 'react';

const BorjomiMarkers = props => (
	<>
		<g id="ic-borjomitrack" transform="translate(2253.000000, 395.000000)">
			<rect id="Rectangle-Copy-4" fill="#2B5E37" fillRule="evenodd" x="5" y="5" width="16" height="16"
						rx="8"/>
			<text id="B" fontFamily="OpenSans-Bold, Open Sans" fontSize="11" fontWeight="normal" fill="#FFFFFF">
				<tspan x="9.3046875" y="17">B</tspan>
			</text>
		</g>
		<g id="ic-borjomitrack" transform="translate(1943.000000, 740.000000)">
			<rect id="Rectangle-Copy-4" fill="#2B5E37" fillRule="evenodd" x="5" y="5" width="16" height="16"
						rx="8"/>
			<text id="B" fontFamily="OpenSans-Bold, Open Sans" fontSize="11" fontWeight="normal" fill="#FFFFFF">
				<tspan x="9.3046875" y="17">B</tspan>
			</text>
		</g>
	</>
);


export default BorjomiMarkers;
